import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState } from 'react'
import usePermissionEngine from "../../../scenes/global/NewSidebar/usePermissionEngine";
import sidebarMenuData from "../../../scenes/global/NewSidebar/sidebarMenu.json";
import DrawerItem from '../DrawerItem/DrawerItem';
import { List } from "@mui/material";
import iconMap from "../../../scenes/global/NewSidebar/iconMap";
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../../General/Logo/Logo';
import ThemeModeSwitcher from '../GlobalComponents/ThemeModeSwitcher/ThemeModeSwitcher';
import { LocalizateCurrentDate } from '../LocalizateCurrentDate/LocalizateCurrentDate';


// import { ReactComponent as FileUploadVector } from '../../../Statics/SampleKartoon.svg';





const drawerWidth = 220;
const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#19686A",   // همون رنگ Drawer
    color: "#fff",
    boxShadow: "none",
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));


// iconMap ماک، دقیقاً با همون کلیدهای بالا (حساس به حروف بزرگ/کوچیک)


const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",

    "& .MuiDrawer-paper": {
        backgroundColor: "#2E7D32", // سبز
        color: "#fff",
        borderRight: "none",
    },

    variants: [
        {
            props: ({ open }) => open,
            style: {
                ...openedMixin(theme),
                "& .MuiDrawer-paper": {
                    ...openedMixin(theme),
                    backgroundColor: "#19686A",
                    color: "#fff",
                },
            },
        },
        {
            props: ({ open }) => !open,
            style: {
                ...closedMixin(theme),
                "& .MuiDrawer-paper": {
                    ...closedMixin(theme),
                    backgroundColor: "#19686A",
                    color: "#fff",
                },
            },
        },

    ],
}));

export default function MiniDrawer() {
    const [selected, setSelected] = useState("داشبورد");
    const [sidebar, setSidebar] = useState(true);
    const filteredMenu = usePermissionEngine(sidebarMenuData.menu);
    const { t } = useTranslation('global');
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };


    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={[{ marginRight: 5 }, open && { display: 'none' }]}>
                        <MenuIcon />

                    </IconButton>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}   >

                        <Typography variant="h6" noWrap component="div">
                            {
                                t('babakTemplateMakers')
                            }
                        </Typography>


                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}  >

                            <Box>
                                <LocalizateCurrentDate />
                            </Box>
                            <Box>
                                <Divider variant='fullWidth' />
                            </Box>
                            <Box>
                                <ThemeModeSwitcher />
                            </Box>
                            
                        </Box>



                    </Box>

                </Toolbar>










            </AppBar>



            <Drawer variant="permanent" open={open}>
                <DrawerHeader>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', p: 2, alignItems: 'center' }}   >
                        <Logo />

                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon sx={{ color: 'white' }} /> : <ChevronLeftIcon sx={{ color: 'white' }} />}
                        </IconButton>
                    </Box>


                </DrawerHeader>


                <Divider />
                <List>
                    {filteredMenu.map((item) => (
                        <DrawerItem
                            key={item.key}
                            item={item}
                            selected={selected}
                            setSelected={setSelected}
                            sidebar={sidebar}
                            iconMap={iconMap}
                        />
                    ))}

                </List>
            </Drawer>



            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader />
                <Outlet />
            </Box>
        </Box>
    );
}
